module.exports = __webpack_public_path__ + "img/meny2.61d607c8.png";